import { api } from "./configs/axiosConfigs";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const DataProvider = {
  getList: async function (
    resource: string,
    params?: any,
    baseUrl: string = "",
    token: string = "",
    cancel: boolean = false
  ) {
    let url = `/${resource}`;
    if (baseUrl) {
      url = baseUrl + url;
    }

    const response = await api.request({
      url,
      method: "GET",
      params,
      ...(token
        ? {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        : {}),
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },
  getOne: async function (
    resource: string,
    params?: any,
    cancel: boolean = false
  ) {
    const { id, ...others } = params;

    const response = await api.request({
      url: `/${resource}/${id}`,
      method: "GET",
      params: others,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },
  post: async function (
    resource: string,
    data?: any,
    cancel: boolean = false,
    baseUrl: string = "",
    responseType?: any
  ) {
    let url = `/${resource}`;
    if (baseUrl) {
      url = baseUrl + url;
    }

    const response = await api.request({
      url,
      method: "POST",
      data: data,
      responseType: responseType,
      headers: data?.contentType,
    });
    return response.data;
  },
  update: async function (
    resource: string,
    data: any = {},
    baseUrl: string = "",
    params = {},
    cancel: boolean = false
  ) {
    const { id, ...others } = data;

    let url = `/${resource}${id ? "/" + id : ""}`;
    if (baseUrl) {
      url = baseUrl + url;
    }

    const response = await api.request({
      url,
      method: "PUT",
      data: others,
      params,
    });

    return response.data;
  },
  delete: async function (
    resource: string,
    params?: any,
    baseUrl: string = "",
    cancel: boolean = false
  ) {
    let url = `/${resource}`;
    if (baseUrl) {
      url = baseUrl + url;
    }
    // const { id, ...others } = params
    const response = await api.request({
      url,
      params,
      method: "DELETE",
    });

    return response.data;
  },
};

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(DataProvider);
